import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lightbox } from '@/components/ui/Lightbox';
import { HERO_IMAGES } from '@/lib/constants';

const GALLERY = [
  { src: HERO_IMAGES.pierna,     alt: 'Pierna Imperial Las Polvillas' },
  { src: HERO_IMAGES.espaldilla, alt: 'Espaldilla Las Polvillas' },
  { src: HERO_IMAGES.productos,  alt: 'Productos Las Polvillas' },
];

export function HistoriaSection() {
  const [lightboxIdx, setLightboxIdx] = useState<number | null>(null);

  return (
    <section id="historia">
      <div className="wrap historia-grid">
        <div className="historia-text reveal-left">
          <span className="eyebrow">Desde 2016</span>
          <h2 className="st">NUESTRA<br />HISTORIA</h2>
          <p>
            En Empacadora Las Polvillas, nos hemos dedicado desde el año 2016 a la producción de
            embutidos de alta calidad, abarcando desde opciones económicas hasta productos premium
            que destacan por su sabor y frescura. Nuestra pasión por la excelencia y el compromiso
            con nuestros clientes nos han permitido crecer y consolidarnos como un referente en el
            mercado.
          </p>
          <p>
            Nuestra línea incluye una amplia variedad de embutidos: jamones, tocino, chorizos y
            longanizas, así como especialidades en ahumados, cocidos y pierna española. Cada
            producto es elaborado con materias primas seleccionadas importadas desde Estados Unidos.
          </p>
          <Link to="/catalogo" className="btn" style={{ marginTop: 20 }}>CONOCER PRODUCTOS</Link>
        </div>

        <div className="historia-imgs reveal-right">
          {GALLERY.map((g, i) => (
            <div key={g.src} className="sk loaded" onClick={() => setLightboxIdx(i)} style={{ cursor: 'zoom-in' }}>
              <img src={g.src} alt={g.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      {lightboxIdx !== null && (
        <Lightbox images={GALLERY} initialIndex={lightboxIdx} onClose={() => setLightboxIdx(null)} />
      )}
    </section>
  );
}
